import { BannerId, ImageItem } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT = 'UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT';
export type UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT = typeof UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT;

export interface UpdateImagesInternalForGalleryEdit {
    type: UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT;
    bannerId: BannerId;
    resourceId: InternalResourceId;
    images: ImageItem[];
}

export function updateImagesInternalForGalleryEditAction(
    bannerId: BannerId,
    resourceId: InternalResourceId,
    images: ImageItem[]
): UpdateImagesInternalForGalleryEdit {
    return {
        type: UPDATE_IMAGES_INTERNAL_FOR_GALLERY_EDIT,
        bannerId,
        resourceId,
        images
    };
}
